import api from './axios';

/**
 * Create a KPI review when no review.id exists yet.
 * body must include: review_type_id, key_performance_indicator_id
 */
export async function createReview({ reviewTypeId, kpiId, body }) {
    const payload = {
        review_type_id: reviewTypeId,
        key_performance_indicator_id: kpiId,
        ...body,
    };
    const { data } = await api.post('/api/reviews', payload);
    return data;
}

/**
 * Update a KPI review when review.id exists.
 */
export async function updateReview({ reviewId, body }) {
    const { data } = await api.put(`/api/reviews/${reviewId}`, body);
    return data;
}

/**
 * Upsert convenience: if reviewId is provided -> update; otherwise -> create
 */
export async function upsertReview({ reviewId, reviewTypeId, kpiId, body }) {
    if (reviewId) {
        return updateReview({ reviewId, body });
    }
    return createReview({ reviewTypeId, kpiId, body });
}